module.exports = {"370831001":"泗河街道","370831002":"济河街道","370831101":"泉林镇","370831102":"星村镇","370831103":"柘沟镇","370831104":"金庄镇","370831105":"苗馆镇","370831106":"中册镇","370831107":"杨柳镇","370831108":"泗张镇","370831109":"圣水峪镇","370831110":"高峪镇","370831111":"华村镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370831.json
// module id = 1321
// module chunks = 0